import { trackMetricsLoaded } from './internal/trackMetricsLoaded';
export { createMetricsFactory } from './internal/createMetricsFactory';
export { setBeaconApi, setStaticAppInfo } from './internal/metricsApi';
export { initProjectErrorMetrics } from './internal/daemon/initProjectErrorMetrics';
trackMetricsLoaded();